import { ICenter } from "./center";

 export interface IFullRecipient {
    id: number;
    isDeleted: boolean;
    alias: string;
    bloodType: string;
    hlaA1: number;
    hlaA2: number;
    hlaB1: number;
    hlaB2: number;
    hlaDr1: number;
    hlaDr2: number;
    antibodyA: string;
    antibodyB: string;
    antibodyDr: string;
    antibodyDr51: boolean;
    antibodyDr52: boolean;
    antibodyDr53: boolean;
    antibodyDq: string;
    antibodyBw: string;
    antibodyCw: string;
    antibodyDp: string;
    antibodyDqa: string;
    dateOfBirth: Date;
    exportableDaysInNkr: number;
    isInChip: boolean;
    position: number;
    statusId: number;
    surgeonContactId: number;
    transplantDate: Date;
    logisticsProvider: string;
    courierJobNumber: string;
    centerId: number;
    cpra4: number;
    storedCpra4: number;
    storedPostPrefMatchesC: number;
    storedExportableCount: number;
    clusterId: number;
    center: ICenter;
}
